import {Component, Input} from "@angular/core";
import {Subscription} from "rxjs/internal/Subscription";
import {UserHttpClientService} from "src/app/data/user-http-client.service";
import {UserWallet} from "src/app/models/User/user-wallet";
import {ModalPaymentService} from "src/app/services/ux/modal-payment.service";
import {toastrService} from "src/app/services/ux/toastr.service";
import {WalletService} from "src/app/services/wallet.service";
import {PaymentHub} from "../../../services/Hub/hub.payment.service";
import {PaymentResponse} from "../../../models/Payment/payment-response";
import {TransactionStatusEmitter} from "src/app/models/Payment/Emitters/transaction-status-emitter";
import {interval, Observable} from "rxjs";
import {take} from "rxjs/operators";
import { TranslateService } from "@ngx-translate/core"

interface PaymentMethod {
    code: string;
    title: string;
    image: string;
}

@Component({
    selector: "app-modal-payment-content",
    templateUrl: "modal-payment-content.component.html",
    styleUrls: ["./modal-payment-content.component.css"]
})
export class ModalPaymentContentComponent {
    // region Mesazhet qe vijn nga hub
    hasHubSentMessage: boolean = null;

    private _paymentErrorHub: PaymentResponse;

    public get paymentErrorHub(): PaymentResponse {
        return this._paymentErrorHub;
    }

    public set paymentErrorHub(value: PaymentResponse) {
        this.hasHubSentMessage = !!Object.keys(value).length;
        this._paymentErrorHub = value;
    }

    private _paymentSuccessHub: PaymentResponse;

    get paymentSuccessHub(): PaymentResponse {
        return this._paymentSuccessHub;
    }

    set paymentSuccessHub(value: PaymentResponse) {
        this.hasHubSentMessage = !!Object.keys(value).length;
        this._paymentSuccessHub = value;
    }

    private _rejectSignal: boolean = null;

    get rejectSignal(): boolean {
        return this._rejectSignal;
    }

    set rejectSignal(value: boolean) {
        this.hasHubSentMessage = value;
        this._rejectSignal = value;
    }

    //#endregion

    // region Subscription
    // * I vetmi sub qe nuk behet dispose sepse duhet me ruajt gjendjen e modales
    modalEvent: Subscription;

    subscription: Subscription;
    hubErrorSub: Subscription;
    hubSuccessSub: Subscription;
    hubRejectSub: Subscription;
    //#endregion

    isLoading = false;

    //#region * Timer Manager
    timerSubs: Subscription = new Subscription();
    paymentTime: Observable<number>;
    seconds = 90;

    shouldRetryPaymentOption = false;
    //#endregion

    // region Payment Method

    readonly paymentMethods: PaymentMethod[] = [];

    // * true if has payment method selected
    hasSelectedPaymentMethod = false;

    // * Payment method
    private _selectedPaymentMethod: PaymentMethod;

    public set selectedPaymentMethod(value: PaymentMethod) {
        this._selectedPaymentMethod = value;
        // * Change hasSelectedPayment depending if selectedPaymentMethod has a valid value
        this.hasSelectedPaymentMethod = !!Object.keys(value).length;
    }

    public get selectedPaymentMethod(): PaymentMethod {
        return this._selectedPaymentMethod;
    }

    //#endregion

    // region User Wallets
    userWallets: UserWallet[] = [];

    hasSelectedWallet = false;

    private _selectedWallet: UserWallet;

    public get selectedWallet(): UserWallet {
        return this._selectedWallet;
    }

    public set selectedWallet(value: UserWallet) {
        this._selectedWallet = value;
        this.hasSelectedWallet = !!value;
    }

    //#endregion

    // region Transaction Status

    isPaymentRequestSent = false;

    private _transactionDetails: TransactionStatusEmitter;

    public get transactionDetails(): TransactionStatusEmitter {
        return this._transactionDetails;
    }

    public set transactionDetails(value: TransactionStatusEmitter) {
        this._transactionDetails = value;
        this.isPaymentRequestSent = !!Object.keys(value).length;
    }

    //#endregion

    amountOfTransactionBeingProcessed: number;

    private _komisioncc = 50.0;

    @Input()
    set komisioncc(value: number) {
        this._komisioncc = value || 0;
    }

    get getKomisionCC(): number {
        return this._komisioncc;
    }

    title = "";

    constructor(
        private modalService: ModalPaymentService,
        private toastr: toastrService,
        public walletService: WalletService,
        private _hub: PaymentHub,
        private userClient: UserHttpClientService,
        private translateService: TranslateService
    ) {
        this.paymentMethods = [
          {code: "wallet", title: "E-Wallet", image: "ewallet_icon.png"},
          {
              code: "creditcard",
              title: this.translateService.instant("Services.CreditCard"),
              image: "payment_creditcard.png"
          }
        ]
        this.title = this.translateService.instant("Services.ChoosePaymentMethod")
        this.modalEvent = modalService.modalState$.subscribe((open) => {
            if (!open) {
                this.resetPayment(false);
            } else {
                this.paymentErrorHub = {} as PaymentResponse;
                this.paymentSuccessHub = {} as PaymentResponse;
                this.transactionDetails = {} as TransactionStatusEmitter;

                this.subscription = walletService.$transactionProgress.subscribe(
                    (transactionDet) => {
                        this.countDown(90);
                        this.title = transactionDet.isSuccess 
                          ? this.translateService.instant("Services.PaymentIsBeingMade") 
                          : this.translateService.instant("Services.PaymentNotMade");
                        this.isLoading = transactionDet.isSuccess;
                        this.transactionDetails = transactionDet;
                    }
                );

                this.hubErrorSub = this._hub.$errorMessageEmitter.subscribe(
                    (signal: PaymentResponse) => {
                        this.title = this.translateService.instant("Services.AnErrorOccured");
                        this.isLoading = false;
                        this.paymentErrorHub = signal;
                        this.resetCountDown();
                        this.walletService.emitTransactionFinish(false);
                    }
                );

                this.hubSuccessSub = this._hub.$successMessageEmitter.subscribe(
                    (signal: PaymentResponse) => {
                        this.title = this.translateService.instant("Services.PaymentIsMadeSuccessfully");
                        this.isLoading = false;
                        this.paymentSuccessHub = signal;
                        this.resetCountDown();
                        this.walletService.emitTransactionFinish(true);
                    }
                );

                this.hubRejectSub = this._hub.$rejectSignalEmitter.subscribe(
                    (signal: boolean) => {
                        this.title = this.translateService.instant("Services.PaymentNotAccepted");
                        this.isLoading = false;
                        this.rejectSignal = signal;
                        this.resetCountDown();
                        this.walletService.emitTransactionFinish(false);
                    }
                );
            }
        });
    }

    private resetCountDown() {
        this.timerSubs.unsubscribe();
        this.paymentTime = new Observable<number>();
        this.seconds = 90;
    }

    continuePayment(): void {
        if (!this.hasSelectedPaymentMethod) {
            return;
        }

        switch (this.selectedPaymentMethod.code) {
            case "creditcard":
                this.isLoading = true;
                this.walletService.emitCreditCardReady();
                break;

            case "wallet":
                this.processPayment();
                break;
            default:
                break;
        }
    }

    selectPaymentMethod(selectedMethod: PaymentMethod) {
        this.selectedPaymentMethod = selectedMethod;
        if ((selectedMethod.code === "wallet")) {
            this._hub.buildConnection();
            this._hub.startConnection();

            this.loadWallets();
        } else {
            this.continuePayment();
        }
    }

    private loadWallets() {
        if (this.hasSelectedPaymentMethod) {
            this.title = this.translateService.instant("Services.ChooseWallet");
            this.userClient.getUserWallets().subscribe({
                next: (res: UserWallet[]) => {
                    this.userWallets = res;
                    if (res.length === 1) {
                        this.selectWallet(this.userWallets[0]);
                    }
                }
            });
            this.amountOfTransactionBeingProcessed = this.walletService.amountOfTransaction;
        }
    }

    // * startPoint => Value of timer continuing to go down
    private countDown(startPoint: number) {
        if (this.isLoading) {
            return;
        }
        // * Fire Every Second for x times (startPoint)
        this.paymentTime = interval(1000).pipe(take(startPoint));

        // * Fire incremental number on every second
        this.timerSubs = this.paymentTime.subscribe({
            next: (second: number) => {
                // * Add second +1 because it start at 0
                ++second;
                this.seconds = startPoint - second;
            },
            complete: () => {
                this.shouldRetryPaymentOption = true;
                this.isLoading = false;
            }
        });
    }

    selectWallet(wallet) {
        this.selectedWallet = wallet;
        this.walletService.selectWallet(wallet);
    }

    processPayment() {
        if (!this.hasSelectedWallet) {
            return this.toastr.warning(this.translateService.instant("Services.PLEASECHOOSEACCOUNT"));
        }

        this.walletService.emitWalletReady();
    }

    resetPayment(shouldClose: boolean = true) {
        if (shouldClose) {
            this.modalService.close();
        }

        this.selectedPaymentMethod = {} as PaymentMethod;

        this.selectedWallet = {} as UserWallet;

        this.userWallets = [] as UserWallet[];

        this.transactionDetails = {} as TransactionStatusEmitter;

        this.title = this.translateService.instant("Services.ChoosePaymentMethod");
        if (this.hasSelectedPaymentMethod) {
            this._hub.hubConnection.stop();
        }

        this.isLoading = false;
        this.UnsubAllSubs();
        this.resetHubFields();
    }

    private resetHubFields() {
        this.paymentErrorHub = {} as PaymentResponse;
        this.paymentSuccessHub = {} as PaymentResponse;
        this.rejectSignal = null;
    }

    private UnsubAllSubs() {
        this.subscription.unsubscribe();
        // this.modalEvent.unsubscribe();

        this.hubErrorSub.unsubscribe();
        this.hubSuccessSub.unsubscribe();
        this.hubRejectSub.unsubscribe();
    }
}
